import { createFileRoute, redirect } from '@tanstack/react-router'
import { rentalListSearchSchema, RentalOrderDetails } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/$rentalId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.rentalId)) || Number(params.rentalId) < 1) {
      throw redirect({ to: '/orders/rentals', search: { current: 1, pageSize: 20 } })
    }
  },
  validateSearch: rentalListSearchSchema,
  component: RentalDetailPage
})
function RentalDetailPage() {
  return <RentalOrderDetails rentalOrderId={Number(Route.useParams().rentalId)} search={Route.useSearch()} />
}
